<template>
    <PageLayoutForms>
        <template #header>
            <h1 class="pdp-mandate-onboarding__title typographies-heading-h1">
                {{ $t.__('pdp.mandate.Onboarding.title') }}
            </h1>
        </template>
        <template #sidebar-left>
            <OnboardingSidebar />
        </template>
        <template #content>
            <CompassInformationBanner
                :title="$t.__('pdp.mandate.Onboarding.InformationBanner.title')"
                sourceIllustration="/ressources/logged/img/illustrations/pdp/invoicing-blocked.svg"
            >
                <template #description>
                    <div
                        class="pdp-mandate-onboarding__information typographies-paragraph-medium-regular"
                        v-html="informationBannerDescription"
                    />
                </template>
            </CompassInformationBanner>
            <template v-if="isAdmin">
                <h2 class="pdp-mandate-onboarding__subtitle typographies-heading-h2">
                    {{ $t.__('pdp.mandate.Onboarding.subtitle') }}
                </h2>
                <div class="pdp-mandate-onboarding__choices">
                    <OnboardingChoice
                        v-for="choice in ['issue', 'receipt']"
                        :key="choice"
                        :type="choice"
                        :disabled="disableMandateType && choice === 'issue'"
                        :state="choiceState(choice)"
                        @select="(selected) => (localMandateType = selected)"
                    />
                </div>
            </template>
            <CompassEmptyState
                v-else
                :title="$t.__('pdp.mandate.Onboarding.EmptyState.title')"
                :caption="$t.__('pdp.mandate.Onboarding.EmptyState.caption')"
                illustrationPath="/ressources/logged/img/illustrations/contact-unlocked.svg"
            />
        </template>
        <template #footer>
            <FooterFullPage :primaryAction="primaryAction" :secondaryActions="secondaryActions" />
        </template>
    </PageLayoutForms>
</template>
<script>
import OnboardingSidebar from 'vcomponents/pa/mandate/Onboarding/OnboardingSidebar.vue';
import FooterFullPage from 'vcomponents/common/FooterFullPage/FooterFullPage.vue';
import OnboardingChoice from 'vcomponents/pa/mandate/Onboarding/OnboardingChoice.vue';
import { createNamespacedHelpers } from 'vuex';
import PageLayoutForms from 'vcomponents/common/layout/pages/PageLayoutForms.vue';
const { mapState: mapStateUser } = createNamespacedHelpers('user');

export default {
    components: {
        OnboardingSidebar,
        FooterFullPage,
        OnboardingChoice,
        PageLayoutForms,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        disableMandateType: {
            type: Boolean,
            default: false,
        },
        selectedMandateType: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            informationBannerDescription: this.$t.__(
                'pdp.mandate.Onboarding.InformationBanner.description',
                {
                    paragraphStart: '<p>',
                    paragraphEnd: '</p>',
                    boldStart: '<strong>',
                    boldEnd: '</strong>',
                },
            ),
            localMandateType: this.selectedMandateType,
        };
    },
    computed: {
        ...mapStateUser(['isAdmin']),
        primaryAction() {
            return {
                label: this.$t.__('pdp.mandate.Onboarding.primaryAction.label'),
                loading: this.loading,
                disabled: !this.isAdmin || !this.localMandateType.length,
                action: () => {
                    this.$emit('mandateTypeSelected', this.localMandateType);
                },
            };
        },
        secondaryActions() {
            return [
                {
                    label: this.$t.__('common.actions.cancel'),
                    action: () => {
                        this.$router.push({ name: 'dashboard' });
                    },
                },
            ];
        },
    },
    methods: {
        choiceState(type) {
            if (!this.localMandateType.length) {
                return 'default';
            }
            return this.localMandateType.includes(type) ? 'selected' : 'unselected';
        },
    },
};
</script>
<style lang="scss" scoped>
.pdp-mandate-onboarding {
    &__subtitle {
        margin: var(--spacing-5) 0 var(--spacing-3);
    }

    &__information {
        color: var(--colors-common-text-brand-secondary-blue);

        &:deep(p) {
            margin: 0;

            & + p {
                margin-top: var(--spacing-3);
            }
        }
    }

    &__choices {
        display: flex;
        gap: var(--spacing-4);
    }

    &:deep(.compass-empty-state) {
        margin: var(--spacing-5) 0 0;
    }
}
</style>
